import { useContext } from 'react';
import AlertContext from '../AlertContext';

const useAlerts = () => useContext(AlertContext);

export default useAlerts;
